import { styled } from "@mui/material";
import MuiDrawer, { drawerClasses } from "@mui/material/Drawer";

const StyledDrawer = styled(MuiDrawer)(({ theme }) => ({
  flexShrink: 0,
  boxSizing: "border-box",
  mt: 10,
  zIndex: theme.zIndex.drawer + 2,
  transition: "width 225ms cubic-bezier(0, 0, 0.2, 1)",
  [`& .${drawerClasses.paper}`]: {
    boxSizing: "border-box",
    transition: "width 225ms cubic-bezier(0, 0, 0.2, 1)",
  },
}));

export default StyledDrawer;